import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import auth from '@it-enterprise/jwtauthentication';
import { i18n } from '@/plugins/i18n';

export const createApoloClient = (grapgUri, schema, connectToDevTools) => {
  const httpLink = new HttpLink({
    uri: grapgUri,
  });

  const authLink = setContext(async (_, { headers }) => {
    const token = await auth.getToken();
    return {
      headers: {
        ...headers,
        'Accept-Language': i18n.locale,
        Authorization: `Bearer ${token}`,
        schema,
      },
    };
  });

  const apolloClientOptions = {
    link: authLink.concat(httpLink),
    connectToDevTools,
    cache: new InMemoryCache(),
  };

  return new ApolloClient(apolloClientOptions);
};
